export const ROLES = ["super-admin", "admin", "coach", "support", "factory-worker", "user"];

// Ids of the rows in the API `roles` table
export const ROLES_MAPPING: { [key: string]: number } = {
    "root": 1,
    "super-admin": 2,
    "admin": 3,
    "coach": 4,
    "support": 5,
    "user": 6,
    // todo: confirm the id created by the API migration in prod
    "factory-worker": 7,
}

// Roles each role is allowed to assign or remove
export const ROLE_PERMISSION_MAPPING: { [key: string]: string[] } = {
    //  "root" : [ "super-admin": >
    "root": ["super-admin", "admin", "coach", "support", "factory-worker", "user"],
    "super-admin": ["super-admin", "admin", "coach", "support", "factory-worker", "user"],
    "admin": ["admin", "coach", "support", "factory-worker", "user"],
    "coach": [],
    "support": ["coach", "support", "user"],
    "factory-worker": [],
    "user": [],
}

// Roles allowed to create users (POST /admin/users is admin and above)
export const CREATE_USER_ROLES = ["root", "super-admin", "admin"];
